var map = {
	"./AInews.png": 967,
	"./bokjichance.png": 508,
	"./buyis.png": 41,
	"./catchTable.png": 735,
	"./dagachi.png": 200,
	"./dancing-cat.png": 115,
	"./gamengg.png": 736,
	"./homepage.png": 806,
	"./homepage2.png": 830,
	"./jirachi-Photoroom.png": 332,
	"./letter-app.png": 897,
	"./nmk.png": 540,
	"./ollama.png": 826,
	"./scm.png": 928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 513;